<template>
    <div class="center">
        <div class="header-bg">
            <div class="user-card">
                <div class="avatar-wrap">
                    <img :src="require('../../../assets/img/personal/userHead.png')" class="avatar" />
                </div>
                <div class="user-info">
                    <div class="user-name" v-if="userInfo.userNameNeedTranslate == '1'">
                        <TranslationOpenDataText type='userName' :openid='userInfo.name'></TranslationOpenDataText>
                    </div>
                    <div class="user-name" v-else>{{ userInfo.name }}</div>
                    <div class="user-company">
                        <van-icon name="shop-o" size="12" />
                        <span>{{ userInfo.companyName || '暂无公司信息' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <main class="main-content">
            <div class="section-card">
                <div class="section-title">
                    <van-icon name="info-o" class="section-icon" />
                    <span>版本信息</span>
                </div>
                <div class="info-item">
                    <div class="info-left">
                        <van-icon name="gem-o" class="item-icon" />
                        <span class="item-label">当前版本</span>
                    </div>
                    <span class="item-value">{{ version || '—' }}</span>
                </div>
            </div>

            <div class="section-card">
                <div class="section-title">
                    <van-icon name="contact" class="section-icon" />
                    <span>账号信息</span>
                </div>
                <div class="info-item" v-if="userInfo.userNameNeedTranslate != '1'">
                    <div class="info-left">
                        <van-icon name="phone-o" class="item-icon" />
                        <span class="item-label">账号</span>
                    </div>
                    <span class="item-value">{{ userInfo.phone || '—' }}</span>
                </div>
                <div class="divider" v-if="userInfo.userNameNeedTranslate != '1'"></div>
                <div class="info-item">
                    <div class="info-left">
                        <van-icon name="manager-o" class="item-icon" />
                        <span class="item-label">角色</span>
                    </div>
                    <span class="item-value">{{ userInfo.roleName || '—' }}</span>
                </div>
                <div class="divider" v-if="userInfo.jobNumber"></div>
                <div class="info-item" v-if="userInfo.jobNumber">
                    <div class="info-left">
                        <van-icon name="idcard" class="item-icon" />
                        <span class="item-label">工号</span>
                    </div>
                    <span class="item-value">{{ userInfo.jobNumber }}</span>
                </div>
                <div class="divider"></div>
                <div class="info-item">
                    <div class="info-left">
                        <van-icon name="shop-o" class="item-icon" />
                        <span class="item-label">公司</span>
                    </div>
                    <span class="item-value">{{ userInfo.companyName || '—' }}</span>
                </div>
                <div class="divider"></div>
                <div class="info-item">
                    <div class="info-left">
                        <van-icon name="calendar-o" class="item-icon" />
                        <span class="item-label">有效日期</span>
                    </div>
                    <span class="item-value">{{ expirationDate || '—' }}</span>
                </div>
            </div>

            <div class="section-card">
                <div class="section-title">
                    <van-icon name="apps-o" class="section-icon" />
                    <span>更多服务</span>
                </div>
                <div class="info-item clickable" @click="instructions()">
                    <div class="info-left">
                        <van-icon name="description" class="item-icon" />
                        <span class="item-label">使用说明</span>
                    </div>
                    <van-icon name="arrow" class="arrow-icon" />
                </div>
                <div class="divider"></div>
                <div class="info-item clickable" @click="tokefu()">
                    <div class="info-left">
                        <van-icon name="service-o" class="item-icon" />
                        <span class="item-label">在线客服</span>
                    </div>
                    <van-icon name="arrow" class="arrow-icon" />
                </div>
                <div class="divider" v-if="wxManager"></div>
                <div class="info-item clickable" v-if="wxManager" @click="addEmployee()">
                    <div class="info-left">
                        <van-icon name="friends-o" class="item-icon" />
                        <span class="item-label">添加员工</span>
                    </div>
                    <van-icon name="arrow" class="arrow-icon" />
                </div>
                <div class="divider"></div>
                <div class="info-item clickable" @click="applicationMarket()">
                    <div class="info-left">
                        <van-icon name="shop-collect-o" class="item-icon" />
                        <span class="item-label">应用市场</span>
                    </div>
                    <van-icon name="arrow" class="arrow-icon" />
                </div>
            </div>

            <div class="section-card" v-if="userInfo.userNameNeedTranslate != '1' && (isCorpWX || isWX)">
                <div class="section-title">
                    <van-icon name="wechat" class="section-icon wechat-icon" />
                    <span>微信绑定</span>
                </div>
                <div class="info-item clickable" @click="bindWeiXin">
                    <div class="info-left">
                        <van-icon name="wechat" class="item-icon wechat-icon" />
                        <div>
                            <span class="item-label">绑定{{ isCorpWX ? '企业' : '' }}微信</span>
                            <p class="item-desc">绑定后可接收工时填报提醒</p>
                        </div>
                    </div>
                    <div class="info-right">
                        <span
                            v-if="(isCorpWX && userInfo.corpwxUserid == null) || (isWX && userInfo.wxOpenid == null)"
                            class="status-tag status-unbound"
                        >未绑定</span>
                        <span
                            v-if="(isCorpWX && userInfo.corpwxUserid != null) || (isWX && userInfo.wxOpenid != null)"
                            class="status-tag status-bound"
                        >已绑定</span>
                        <van-icon name="arrow" class="arrow-icon" />
                    </div>
                </div>
            </div>

            <div class="logout-wrap" v-if="!isCorpWX">
                <van-button class="logout-btn" block round @click="logout">
                    <van-icon name="revoke" />
                    <span>退出登录</span>
                </van-button>
            </div>
            <div class="logout-wrap" v-if="isCorpWX && userInfo.corpwxUserid != null && userInfo.userNameNeedTranslate != '1'">
                <van-button class="logout-btn" block round @click="unbindCorpWX">
                    <van-icon name="revoke" />
                    <span>解除绑定</span>
                </van-button>
            </div>

            <div class="version-info">CTMS 临床管家</div>
        </main>

        <Footer page="my" />
    </div>
</template>

<script>
    import Footer from "@/components/Footer";
    import { mapGetters } from "vuex";
    export default {
        components: {
            Footer
        },

        computed: {
            ...mapGetters(["userId", "isLogin"])
        },

        data() {
            return {
                userInfo: JSON.parse(localStorage.userInfo),
                isCorpWX:false,
                isWX:false,
                expirationDate: '',
                version: '',
                show: false,
                wxManager: false,
            }
        },

        methods: {
            applicationMarket() {
                window.location.href = 'https://www.ttkuaiban.com/appMarket.html'
            },
            logout() {
                this.$dialog.confirm({
                    title: '退出登录',
                    message: '确定要退出当前账号吗？',
                    confirmButtonText: '退出',
                    confirmButtonColor: '#ee0a24',
                }).then(() => {
                    this.$store.commit("updateLogin", false);
                    localStorage.removeItem("userInfo");
                    this.$router.push("/login");
                }).catch(() => {});
            },
            unbindCorpWX() {
                this.$dialog.confirm({
                    title: '',
                    message: '解除绑定后只能通过账号密码登录，您确定吗？'
                }).then(() => {
                    this.$axios.post("/user/unbindCorpWX", {userId: this.userInfo.id})
                    .then(res => {
                        if(res.code == "ok") {
                            this.$store.commit("updateLogin", false);
                            localStorage.removeItem("userInfo");
                            this.$router.push("/login");
                        } else {
                            this.$toast.clear();
                            this.$toast.fail(res.msg);
                        }
                    }).catch(err=> {this.$toast.clear();});
                }).catch(() => {
                });
            },
            bindWeiXin(){
                if (this.isCorpWX && this.userInfo.corpwxUserid != null) {
                    return;
                }
                else if (this.isWX && this.userInfo.wxOpenid != null) {
                    return;
                }
                var appId = "wx749c84daac654e1e";
                var url = "http://mobctms.ttkuaiban.com/api/wechat/bindWeiXin2?userId="+this.userInfo.id;
                if (this.isCorpWX) {
                    appId = "wwd897aca09d69b16b";
                    url = "http://ctms.ttkuaiban.com/api/wxcorp/bindCorpWeiXin?userId="+this.userInfo.id;
                }

                var weixinUrl="https://open.weixin.qq.com/connect/oauth2/authorize?appid="+appId+"&redirect_uri="+encodeURI(url)+"&response_type=code&scope=snsapi_base&state=0#wechat_redirect";
                window.location.href = weixinUrl;
            },
            instructions() {
                let url = 'http://celiang.oss-cn-hangzhou.aliyuncs.com/measurement/2022-01/18/75it6phpocqYFV1642488558220118.pdf'
                let name = '使用说明书'
                this.previewPDF(url, name)
            },
            previewPDF(url, name) {
                this.$router.push({
                    path:  '/pdf',
                    query: {
                        url: '',
                        name: name
                    }
                })
            },
            addEmployee() {
                wx.invoke('openAppManage', {}, function(res){
                    if(res.err_msg == "openAppManage:fail:no permission") {
                        this.$message({message: '调用人身份不符合',type: "error"});
                    }
                })
            },
            tokefu(){
                wx.invoke('openThirdAppServiceChat', {
                    }, function(res) {
                        if (res.err_msg != "openThirdAppServiceChat:ok" && res.err_msg != "openThirdAppServiceChat:cancel") {
                            this.$toast.fail('请联系管理员添加客服');
                        }
                    }
                );
            },
            getWxManager() {
                this.$axios.post("/user/isManager", {})
                .then(res => {
                    if(res.code == "ok") {
                        this.wxManager = res.data + '' == 'true'
                    } else {
                        this.$toast.clear();
                        this.$toast.fail(res.msg);
                    }
                }).catch(err=> {this.$toast.clear();});
            }
        },
        mounted() {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf("wxwork") > 0) {
                this.isCorpWX = true;
            } else if (ua.indexOf("micromessenger") > 0) {
                this.isWX = true;
            }

            if(localStorage.userInfo) {
                let userss = JSON.parse(localStorage.userInfo)
                this.expirationDate = userss.company.expirationDate[0] + '-' +
                (userss.company.expirationDate[1] >= 10 ? userss.company.expirationDate[1] : ('0' + userss.company.expirationDate[1]))
                 + '-' + (userss.company.expirationDate[2] >= 10 ? userss.company.expirationDate[2] : ('0' + userss.company.expirationDate[2]))

                userss.company.packageWorktime == 1 ? this.version = '基础版' : ''
                userss.company.packageProject == 1 ? this.version = '专业版' : ''
                userss.company.packageEngineering == 1 ? this.version = '建筑工程版' : ''
                userss.company.packageOa == 1 ? this.version = '旗舰版' : ''
            }

            this.getWxManager()
        }
    };
</script>

<style lang="less" scoped>
.center {
    min-height: 100vh;
    background: #f0f4f8;
    padding-bottom: 70px;
}

.header-bg {
    position: relative;
    height: 220px;
    background: linear-gradient(135deg, #4a90e2 0%, #0d6ecc 60%, #0a5aad 100%);
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: -60px;
        right: -60px;
        width: 200px;
        height: 200px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.08);
    }
}

.user-card {
    position: absolute;
    bottom: 28px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    padding: 0 24px;
}

.avatar-wrap .avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.9);
    display: block;
    object-fit: cover;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    margin-right: 16px;
}

.user-info {
    flex: 1;
    overflow: hidden;

    .user-name {
        font-size: 20px;
        font-weight: 600;
        color: #fff;
        margin-bottom: 8px;
    }

    .user-company {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.8);

        span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

.main-content {
    margin-top: -16px;
    padding: 0 14px;
    position: relative;
    z-index: 1;
}

.section-card {
    background: #fff;
    border-radius: 12px;
    margin-bottom: 14px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.section-title {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 14px 16px 10px;
    font-size: 13px;
    font-weight: 600;
    color: #969799;
    border-bottom: 1px solid #f5f5f5;

    .section-icon {
        color: #4a90e2;
        font-size: 15px;
    }

    .wechat-icon {
        color: #07c160;
    }
}

.info-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    min-height: 52px;

    &.clickable:active {
        background: #f7f8fa;
    }
}

.info-left {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    overflow: hidden;

    .item-icon {
        font-size: 18px;
        color: #4a90e2;
        flex-shrink: 0;
    }

    .wechat-icon {
        color: #07c160;
    }

    .item-label {
        font-size: 15px;
        color: #323233;
        font-weight: 500;
    }

    .item-desc {
        font-size: 12px;
        color: #969799;
        margin: 2px 0 0;
    }
}

.info-right {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
}

.item-value {
    font-size: 14px;
    color: #646566;
    max-width: 55%;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.arrow-icon {
    font-size: 14px;
    color: #c8c9cc;
}

.divider {
    height: 1px;
    background: #f5f5f5;
    margin: 0 16px;
}

.status-tag {
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 10px;
    font-weight: 500;

    &.status-bound {
        color: #07c160;
        background: rgba(7, 193, 96, 0.1);
    }

    &.status-unbound {
        color: #ee0a24;
        background: rgba(238, 10, 36, 0.08);
    }
}

.logout-wrap {
    margin: 10px 0 6px;

    .logout-btn {
        height: 46px;
        border-radius: 23px;
        background: #fff;
        border: 1.5px solid #ee0a24;
        color: #ee0a24;
        font-size: 16px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        box-shadow: 0 2px 8px rgba(238, 10, 36, 0.12);
    }
}

.version-info {
    text-align: center;
    font-size: 12px;
    color: #c8c9cc;
    padding: 12px 0 4px;
}
</style>
